import { render, staticRenderFns } from "./ProfileNavbar.vue?vue&type=template&id=770a32e4&"
import script from "./ProfileNavbar.vue?vue&type=script&lang=js&"
export * from "./ProfileNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports